export default __webpack_public_path__ + "static/media/error.3edfba26.png";